import React from 'react';
import { Route, Routes } from 'react-router-dom';
import App from './App';
import AdminUsers from './AdminUsers';
import TelegramLogin from './TelegramLogin';
import PrivateRoute from './ProtectedRouter';
import { useValidate } from './validateHelper';

const MainRouter = () => {
    const [token, setToken, user] = useValidate();

	return (
        <Routes>
            <Route exact path='/' element={<PrivateRoute isAuth={ token }/>}>
                <Route exact path='/' element={<App />}/>
            </Route>
            <Route exact path='/admin' element={<PrivateRoute isAuth={ token } isAdmin={Boolean(user?.isAdmin)} adminOnly />}>
                <Route exact path='/admin' element={<AdminUsers />}/>
            </Route>
            <Route path="/login" element={<TelegramLogin setToken={setToken}/>} />
        </Routes>
	);
};

export default MainRouter;
